import styled from "@emotion/styled"

const HeroScrollCaseDemoDesktopMobileMobileWrapper = styled.div`
  position: absolute;
  bottom: -20px;
  right: -20px;
  width: 25%;
  height: fit-content;
`
export default HeroScrollCaseDemoDesktopMobileMobileWrapper
